import { defineStore } from 'pinia'
import { useStore } from './DefaultStore';
import Cookies from "js-cookie";
import { getAuth, signOut } from 'firebase/auth';
import ToastService from '@/services/ToastService';
import AuthenticationService from '@/services/AuthenticationService';

export const useSessionStore = defineStore({  
  id: 'sessionStore',

  state: () => (
    {
    }
  ),

  actions: {
    // `showToast` lets a caller that already surfaces its own inline error
    // (e.g. the login screen) opt out of the toast and handle the failure
    // itself — the error is rethrown in that case instead of swallowed.
    async LogOut(showToast = true){
        const auth = getAuth();
        const store = useStore();

        signOut(auth);
        store.SetLoader(true);

        try {
            await AuthenticationService.Logout();
            store.LoggedUser = null;
        }
        catch(e) {
            if(showToast){
                ToastService.Error(e, 'Ocurrió un error al intentar cerrar la sesión');
            }
            else {
                throw e;
            }
        }
        finally {
            store.SetLoader(false);
        }
    },

    async SessionLogout() {
      const store = useStore();
      store.SetLoader(true);

      await AuthenticationService.Logout()
        .then(() => {
          store.LoggedUser = null;
        })
        .catch(e => {
          ToastService.Error(e, 'OCURRIÓ UN ERROR AL INTENTAR CERRAR LA SESIÓN');
        })

      store.SetLoader(false);
    },

    async FirebaseLogout() {
      const auth = getAuth();
      const store = useStore();
      signOut(auth);
      store.LoggedUser = null;
    },

    SetCurrentOrganization(PKOrganization){
        Cookies.set('OrganizationID', PKOrganization);
    },

    // Shared by ProfileMenu's org switcher and OrganizationModal's disable flow —
    // callers still trigger the reload themselves (router.go(0)) once this returns.
    SwitchOrganization(PKOrganization){
        const store = useStore();
        store.CurrentOrganizationPK = PKOrganization;
        store.organizationChanged = true;
        this.SetCurrentOrganization(PKOrganization);
    },

    GetCurrentOrganization(){
        let currentOrganization = Cookies.get('OrganizationID');
        return currentOrganization ? parseInt(currentOrganization) : null;
    }
  }
})